const SENSITIVE_QUERY_KEYS = new Set([
  'ossaccesskeyid',
  'signature',
  'security-token',
  'x-oss-security-token',
  'expires',
  'accesskeyid',
  'access_key_id',
  'accesskeysecret',
  'access_key_secret',
  'ststoken',
  'token',
])

/**
 * 脱敏日志中的临时授权 URL，避免泄露 OSS 签名和 STS token。
 * @param value 原始日志文本。
 * @returns 替换敏感查询参数后的文本。
 */
export function sanitizeSignedUrl(value: string): string {
  return String(value || '').replace(/https?:\/\/[^\s"'<>]+/gi, (rawUrl) => {
    try {
      const url = new URL(rawUrl)
      let changed = false
      for (const key of [...url.searchParams.keys()]) {
        if (!SENSITIVE_QUERY_KEYS.has(key.toLowerCase())) continue
        url.searchParams.set(key, '***')
        changed = true
      }
      return changed ? url.toString() : rawUrl
    } catch {
      return rawUrl
        .replace(/([?&](?:OSSAccessKeyId|Signature|security-token|x-oss-security-token|Expires|AccessKeyId|access_key_id|accessKeySecret|access_key_secret|stsToken|token)=)[^&\s"'<>]+/gi, '$1***')
    }
  })
}

/**
 * 递归脱敏日志载荷中的字符串字段。
 * @param value 任意日志载荷。
 * @returns 已脱敏的日志载荷副本。
 */
export function sanitizeLogValue<T>(value: T): T {
  if (typeof value === 'string') return sanitizeSignedUrl(value) as T
  if (Array.isArray(value)) return value.map((item) => sanitizeLogValue(item)) as T
  if (!value || typeof value !== 'object') return value
  const out: Record<string, unknown> = {}
  for (const [key, item] of Object.entries(value)) {
    out[key] = sanitizeLogValue(item)
  }
  return out as T
}
